export default {
	data() {
		return {
			documentClickedHandler: () => {}
		};
	},
	mounted() {
		document.addEventListener('click', this.mixinHandleDocumentClicked);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.mixinHandleDocumentClicked);
	},
	methods: {
		mixinHandleDocumentClicked(event) {
			const { target } = event;
			const { $el } = this;
			if (!$el.contains(target)) {
				this.documentClickedHandler(target);
			}
		}
	}
};
